import { useMemo } from "react";

export const useRegularPayCode = (map) => {
	return useMemo(() => {
		if (!map) {
			return;
		}

		return map["REG"];
	}, [map]);
};
